import { useState, useEffect } from 'react';
import LendBorrowHOC from 'hoc/LendBorrowHOC';
import { useWeb3React } from '@web3-react/core';
import LoanList from 'components/Loans/LoanList';
import { getLoansForBorrower } from 'services/nftfi';

function LoansPage({}) {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);

  const context = useWeb3React();
  const { account } = context;

  const fetchLoans = async () => {
    if (loading) return;
    try {
      setLoading(true);
      const result = await getLoansForBorrower(account);
      // '0x83615aF49DbEde4709ce9f00771bD7B077453feA' ||
      //   '0x8AB0b38B5331ADAe0EDfB713c714521964C5bCCC' ||
      setLoans(result);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (account) {
      fetchLoans();
    }
  }, [account]);

  return <LoanList title='My Loans' address={account} loans={loans} loading={loading} />;
}

export default LendBorrowHOC(LoansPage, false);
